'use client';

import React, { useEffect } from 'react';

export const LocomotiveScrollProvider = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        (async () => {
            const LocomotiveScroll = (await import('locomotive-scroll')).default;
            const locomotiveScroll = new LocomotiveScroll({
                autoResize: true,
            });

            // locomotiveScroll.scrollTo(0, { duration: 0 }); // Скролл в начало

            // Обработчик якорных ссылок
            document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
                anchor.addEventListener('click', function (e) {
                    try {
                        const targetId = anchor.getAttribute('href')!;
                        const target = document.querySelector(targetId);

                        if (target) {
                            e.preventDefault();

                            locomotiveScroll.scrollTo(target as HTMLElement, {
                                duration: 1.5,
                                offset: -1,
                                lock: true,
                                easing: (t) => Math.min(1, 1.021 - Math.pow(2, -10 * t)),
                            });

                            // Для обновления URL без скачка
                            if (history.pushState) {
                                history.pushState(null, '', targetId);
                            } else {
                                location.hash = targetId;
                            }
                        }
                    } catch (error) {
                        console.error(error);
                        e.returnValue = true;
                    }
                });
            });

            return () => locomotiveScroll.destroy();
        })();
    }, []);
    return <>{children}</>;
};
